module.exports = __webpack_public_path__ + "static/media/Appstore.ad360337.png";